/**
 * workTableAdapter — mappt ProductWithIssues (Issues-Endpoint) auf das
 * ProductWithReadiness-Shape des bestehenden Tabellen-Stacks (P2a/R0:
 * eine Tabelle, kein Parallel-Grid). work_*-Felder tragen die Issue-Details
 * für die Verstöße-Spalte. Product-Pflichtfelder, die der Issues-Endpoint
 * nicht liefert, werden mit neutralen Platzhaltern befüllt (nur für
 * Spalten-Rendering — nie zurückgeschrieben). is_active ist bewusst true
 * (Issues-Endpoint liefert keinen Aktiv-Status; kein Dimming).
 */
import type { ProductIssue, ProductWithIssues } from '@/lib/api/channel-readiness'
import type { ProductWithReadiness } from '@/types/products'

export type IssuesWorkRow = ProductWithReadiness & {
  work_issues: ProductIssue[]
  work_issue_count: number
}

export function toWorkRow(p: ProductWithIssues): IssuesWorkRow {
  return {
    // Identität + angezeigte Felder
    id: p.product_id,
    name: p.name ?? '',
    sku: p.sku ?? null,
    first_image_url: p.thumbnail_url ?? null,
    is_active: true,
    readiness_action_state: p.readiness_action_state,
    issues_count: p.issue_count,
    quantity_30d: p.quantity_30d ?? undefined,
    revenue_30d: p.revenue_30d ?? undefined,
    quantity_90d: p.quantity_90d ?? undefined,
    revenue_90d: p.revenue_90d ?? undefined,
    last_sale_date: p.last_sale_date ?? null,
    // Product-Pflichtfelder (Platzhalter — Issues-Endpoint liefert sie nicht)
    workspace_id: '',
    workspace_integration_id: '',
    external_id: '',
    gtin: null,
    asin: null,
    description: null,
    short_description: null,
    image_url: null,
    price_net: null,
    price_gross: null,
    raw_data: {},
    synced_at: null,
    created_at: '',
    updated_at: '',
    // Arbeitslisten-Zusatz
    work_issues: p.issues ?? [],
    work_issue_count: p.issue_count,
  }
}
